import {
  List,
  MenuItem,
  ListItemIcon,
  popoverClasses,
  menuClasses,
  paperClasses,
  ClickAwayListener,
  Paper,
  ListSubheader,
} from '@mui/material';
import { useEffect, useRef, MouseEvent } from 'react';
import { styled } from '@mui/material/styles';

export const ContextMenu = ({
  menuItems,
  anchorEl,
  setAnchorEl,
}: {
  menuItems: { icon?: React.ReactNode; label: string; onClick: Function }[];
  anchorEl: null | {
    anchor: HTMLElement;
    clientX: any;
    clientY: any;
    data?: any;
  };
  setAnchorEl: React.Dispatch<
    React.SetStateAction<null | {
      anchor: HTMLElement;
      clientX: any;
      clientY: any;
    }>
  >;
}) => {
  // const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const ref = useRef(null);
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (ref.current && !(ref.current as any)?.contains(event.target)) {
        handleCloseMenu();
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const CMenu = styled(List)(({ theme }) => ({
    [`&.${paperClasses.root}`]: {
      // top: `${anchorEl?.clientY}px !important`,
      left: `${anchorEl?.clientX}px !important`,
      backgroundColor: 'red',
      border: '1px solid red',
    },
    [`${menuClasses.paper}`]: {
      // top: `${anchorEl?.clientY}px !important`,
      left: `${anchorEl?.clientX}px !important`,
      backgroundColor: 'red !important',
      border: '1px solid black',
    },
  }));
  return (
    <div ref={ref}>
      <Paper
        elevation={3}
        sx={{
          // mt: '45px',
          position: 'absolute',
          top: `${anchorEl?.clientY}px !important`,
          left: `${anchorEl?.clientX}px !important`,
          visibility: Boolean(anchorEl?.anchor) ? 'visible' : 'hidden',
          zIndex: theme => theme.zIndex.modal + 1,
        }}
      >
        <List
          subheader={
            <ListSubheader
              component="div"
              sx={{ lineHeight: '30px', fontSize: '0.7em' }}
            >
              Browser menu <strong>Alt + Right Click</strong>
            </ListSubheader>
          }
          // id="List-appbar"
          // anchorEl={anchorEl?.anchor}
          // anchorOrigin={{
          //   vertical: 'center',
          //   horizontal: 'center',
          // }}
          // anchorPosition={{
          //   top: 10,
          //   left: 300,
          // }}
          // PopoverClasses={{
          //   root: {
          //     top: `${anchorEl?.clientY}px !important`,
          //     left: `${anchorEl?.clientX}px !important`
          //   }
          // }}
          // keepMounted
          // transformOrigin={{
          //   vertical: 'top',
          //   horizontal: 'right',
          // }}
          // open={Boolean(anchorEl?.anchor)}
          // onClose={handleCloseMenu}
        >
          {menuItems.map(({ icon, label, onClick }, index) => (
            <MenuItem
              id={`List-${label}`}
              key={index}
              onClick={() => {
                handleCloseMenu();
                onClick();
              }}
              sx={{ minWidth: 120, minHeight: 'auto' }}
            >
              {icon && (
                <ListItemIcon id={`List-${label}`}>
                  <div id={`List-${label}`}>{icon}</div>
                </ListItemIcon>
              )}
              {label}
            </MenuItem>
          ))}
        </List>
      </Paper>
    </div>
  );
};
